import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()

export class LocalStorageService {

  set(key: string, data: Object): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch {
      //
    }
  }

  get(key: string): any {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      return null;
    }
  }
}
